config.$inject = [
    '$httpProvider',
    '$interpolateProvider',
    '$sceProvider'
];

export default function config(
    $httpProvider,
    $interpolateProvider,
    $sceProvider
) {
    $interpolateProvider.startSymbol('{[{').endSymbol('}]}');

    $sceProvider.enabled(false);

    $httpProvider.useApplyAsync(true);
    // TODO: $httpProvider.interceptors.push('errorInterceptor');
    $httpProvider.interceptors.push('basicAuthInterceptor');
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
